module.exports = __webpack_public_path__ + "dbb6a83f0bb38465261f68b99832f3f9.jpg";